import { Tabs } from 'antd'
import React, { useContext } from 'react'
import { t } from 'i18next'
import InformationsTab from './InformationsTab'
import EventsTab from './EventsTab'
import FeedbackForm from './FeedbackForm'
import GlobalContext from '../GlobalContext'

export default function AdminAppointmentTabs ({ appointment, setLoading, setAppointment, setIsDirty }) {
  const { screens } = useContext(GlobalContext)
  const maxHeight = screens.xxl ? '60vh' : screens.xl ? '81vh' : '127vh'
  const defaultTabStyle = { overflowY: 'scroll', maxHeight }

  return (
    <Tabs
      defaultActiveKey='informations'
      items={[
        {
          label: t('Admin.AdminAppointmentPage.tab.informations'),
          key: 'informations',
          children: <InformationsTab appointment={appointment} setAppointment={setAppointment} />
        },
        {
          label: t('Admin.AdminAppointmentPage.tab.events'),
          key: 'events',
          children: <EventsTab appointment={appointment} setLoading={setLoading} style={defaultTabStyle} />
        },
        {
          label: t('Admin.AdminAppointmentPage.tab.feedback'),
          key: 'feedback',
          children: <FeedbackForm appointment={appointment} setLoading={setLoading} setAppointment={setAppointment} formStyle={defaultTabStyle} setIsDirty={setIsDirty} />
        }
      ]}
    />
  )
}
